import { createView, defineElement as domvmElement, injectView } from 'domvm';
import { ElementRendererContract } from './ElementRendererContract.js';

export class DomVmElementRenderer extends ElementRendererContract {

    renderElement(tag, css = null, props = null, content = null) {

        const actualTag = this.createSelector(tag, css);
        const actualProps = this.normalizeProps(props);
        const actualContent = this.normalizeContent(content);

        if (actualProps && actualContent !== null) {
            return domvmElement(actualTag, actualProps, actualContent);
        }
        if (actualProps) {
            return domvmElement(actualTag, actualProps);
        }
        if (actualContent !== null) {
            return domvmElement(actualTag, actualContent);
        }
        return domvmElement(actualTag);

    }

    createView(renderFactory, data = null) {
        return createView(renderFactory, data);
    }

    injectView(view, data = null) {
        return injectView(view, data);
    }

    createSelector(tag, css = null) {

        const actualTag = tag || 'div';
        const actualCss = this.normalizeCss(css);
        if (!actualCss) return actualTag;
        if (actualTag.includes('.') || actualTag.includes('#')) {
            return `${actualTag}${actualCss}`;
        }
        return `${actualTag}${actualCss}`;

    }

    normalizeCss(css = null) {

        if (!css) return '';
        if (Array.isArray(css)) {
            return css.map((item) => this.normalizeCss(item)).join('');
        }

        const text = String(css).trim();
        if (!text) return '';
        if (text.startsWith('.') || text.startsWith('#')) return text;

        return text
            .split(/\s+/g)
            .filter(Boolean)
            .map((item) => `.${item}`)
            .join('');

    }

    normalizeProps(props = null) {

        if (!props) return null;

        const normalized = { ...props };
        for (const [key, value] of Object.entries(normalized)) {
            if (value === null || value === undefined || value === false) {
                delete normalized[key];
            }
        }

        return Object.keys(normalized).length ? normalized : null;

    }

    normalizeContent(content = null) {

        if (content === null || content === undefined) return null;
        if (!Array.isArray(content)) return content;
        return content.filter((item) => item !== null && item !== undefined && item !== false);

    }

}
